// closeButtonUI.js
var CloseButtonUi = pc.createScript('closeButtonUi');

// initialize code called once per entity
CloseButtonUi.prototype.initialize = function() {

    this.entity.button.on('click', function(event){ //Play butonu dinlemeye baslar.
        loadScene(`Menu`, { hierarchy: true, settings: true });
    },this);
};


